import React, { useState, useEffect } from 'react';
import DashboardLayout from './DashboardLayout';
import ServiceManager from './ServiceManager';
import configService from '../services/configService';
import { useDataCache } from '../contexts/DataCacheContext';

function Services() {
  const { cache } = useDataCache();
  const [modules, setModules] = useState(cache.settings?.modules || null);
  const [loading, setLoading] = useState(!cache.settings);

  useEffect(() => {
    if (!cache.settings) {
      loadModules();
    } else {
      setModules(cache.settings.modules);
      setLoading(false);
    }
  }, [cache.settings]);

  const loadModules = async () => {
    try {
      const response = await configService.getModules();
      const moduleMap = {};
      response.modules.forEach(m => {
        moduleMap[m.module_id] = m.enabled;
      });
      setModules(moduleMap);
    } catch (error) {
      console.error('Failed to load modules:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!loading && (!modules || !modules.pricing_quotes)) {
    return (
      <DashboardLayout>
        <div className="text-center py-12">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Services Not Available</h2>
          <p className="text-gray-600">The services module is not enabled for your account.</p>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      {loading ? (
        <div className="flex items-center justify-center h-64">
          <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="space-y-6">
          <div className="mb-6">
            <div className="text-4xl font-bold text-gray-900 mb-2">Service Catalog</div>
            <p className="text-sm text-gray-600">Manage your business services and pricing information.</p>
          </div>
          <ServiceManager cachedServices={cache.bookings?.services} />
        </div>
      )}
    </DashboardLayout>
  );
}

export default Services;
